import { ReactNode } from "react";
import { Role } from "./Role";
import PageNotFound from "../PageNotFound";
import { useCerberus } from "../../hooks/useCerberus";
import Loading from "../Widgets/Loading";
import { Alert, Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const RequireRole = ({
  children,
  roles,
}: {
  children: ReactNode;
  roles: Role[];
}) => {
  const { roles: userRoles, loading } = useCerberus();
  const navigate = useNavigate();

  if (loading) {
    return <Loading />;
  }

  let hasAccess = false;

  if (userRoles && userRoles.length > 0) {
    roles.forEach(function (requiredRole) {
      if (userRoles.includes(requiredRole)) hasAccess = true;
    });
  }

  // If user has no roles at all, show a specific message
  if (!userRoles || userRoles.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            Access Restricted
          </Typography>
          <Typography variant="body1" gutterBottom>
            Your account does not have any assigned roles. Please contact your
            administrator to assign appropriate roles to your account.
          </Typography>
        </Alert>
        <Button
          variant="contained"
          onClick={() => navigate("/account")}
          sx={{ mr: 2 }}
        >
          View Account
        </Button>
        <Button variant="outlined" onClick={() => (window.location.href = "/")}>
          Sign Out
        </Button>
      </Box>
    );
  }

  if (!hasAccess) {
    return <PageNotFound />;
  }

  return children;
};

export default RequireRole;
